

export default {
  name: 'EoLogoBeam',
  props: {
    /**
     * Size of the icon: (xs) (sm) (md) (lg) (xl)
     */
    size: {
      type: String,
      default: '',
    },
    /**
     * Style: hex value of color
     */
    color: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      viewbox: {
        small: {x: 18, y: 18},
        large: {x: 60, y: 56},
      },
    }
  },
  computed: {
    activeSize () {
      switch(this.size) {
        case 'xs':
          return 'small'
        case 'sm':
        case 'md':
        case 'lg':
        case 'xl':
          return 'large'
        default:
          return 'large'
      }
    },
  },
}
